export const sitesData = [
  {
    id: 1,
    name: "AI Platform",
    desc: "Comprehensive, integrated AI platform and services",
    code: "ai3si",
    tech: "Umbraco - C# - .NET",
    demoUrl: "https://ai.3si.vn/",
    liveUrl: "https://ai.3si.vn/",
    group: ["AIS"]
  },
  {
    id: 2,
    name: "Crisis Management System",
    desc: "Cloud-based platform to support organizations to manage Risk/Crisis",
    code: "crisis-home",
    tech: "PHP - Yii2 framework",
    demoUrl: "https://crisis.vn",
    // demoUrl: "http://demo.crisis.vn",
    liveUrl: "https://crisis.vn",
    group:["S2","AIS"]
  },
  {
    id: 3,
    name: "tMonitor",
    desc: "Real-time indoor air quality monitoring system using IoT & Machine Learning",
    code: "phuxuan",
    tech: ".NET MVC -ReactJS",
    demoUrl: "http://phuxuan.thinklabs.vn/",
    liveUrl: "http://phuxuan.thinklabs.vn/",
    group: ["AIS"]
  },
  {
    id: 4,
    name: "tRadar",
    desc: "Drone-based remote inspection and quality management system",
    code: "t-radar",
    tech: "NodeJS - ReactJS",
    demoUrl: "http://demo.tradar.3si.vn",
    liveUrl: "http://tradar-alpha.mybluemix.net/",
    group: ["AIS"]
  },
  {
    id: 5,
    name: "tConnect",
    desc: "Citizen Engagement for Local Governments",
    code: "311",
    tech: ".NET Core - ReactJS",
    demoUrl: "http://demo.311.3si.vn",
    liveUrl: "http://311.thinklabs.vn",
    group: ["S2"]
  },
  {
    id: 6,
    name: "EMR",
    desc: "Electronic medical record database management system",
    code: "emr",
    tech: "Angular 7 - ASP.Net - C#",
    demoUrl: "http://emr4.3si.vn/",
    liveUrl: "http://emr4.3si.vn/",
    group: ["HT"]
  },
  {
    id: 7,
    name: "Aibolit",
    code: "aibolit",
    desc: "Real-time telehealthcare and consultation solution",
    tech: "NodeJS - ReactJS",
    demoUrl: "http://demo.aibolit.3si.vn",
    liveUrl: "http://aibolit.thinklabs.vn",
    group: ["AIS","HT"]
  },
  {
    id: 8,
    name: "UMS",
    desc: "Comprehensive university management system and web portal for teachers and students",
    code: "ums",
    tech: "C# - .NET - ReactJS",
    demoUrl: "http://pum.3si.vn/",
    liveUrl: "http://pum.3si.vn/",
    group: ["ET"]
  },
  {
    id: 9,
    name: "LMS",
    desc: "Robust learning management system for dynamic courses",
    code: "lms",
    tech: "Open edX - Python - ReactJs - Django...",
    demoUrl: " ",
    liveUrl: " ",
    group: ["ET"]
  },
  {
    id: 10,
    name: "Senses Lounge",
    desc: "NFC-based food court Operation Management",
    tech: ".NET - Umbraco CMS",
    code: "senses-lounge",
    demoUrl: "http://foodcourt.demo.3si.vn",
    liveUrl: "http://senseslounge.3si.vn",
    group: ["S2"]
  },
  {
    id: 11,
    name: "Naman Retreat",
    desc: "CMS solution for Hotel & Resort website",
    tech: ".NET - Umbraco CMS",
    code: "naman-retreat",
    demoUrl: "http://naman.demo.3si.vn",
    liveUrl: "https://www.namanretreat.com",
    group: ["S1"]
  },
  {
    id: 12,
    name: "Farm2Go",
    desc: "Online marketplace for farms, farmers and their suppliers",
    code: "farm-2-go",
    tech: "PHP - Wordpress CMS",
    demoUrl: "http://demo.farm2go.3si.vn",
    liveUrl: "https://farm2go.thinklabs.vn/",
    group: ["AIS"]
  },
  {
   
    id: 13,
    name: "Shopapp",
    desc: "CMS mobile solution for online shops",
    code: "shopapp",
    tech: "PHP - Yii framework",
    demoUrl: "http://shopapp.vn",
    // demoUrl: "http://demo.shopapp.vn",
    liveUrl: "http://shopapp.vn",
    group:["S1"]
  },
  {
    id: 14,
    name: "Umbraco Template",
    desc: "Flexible and highly customizable templates to build anything",
    code: "umbraco-template",
    tech: ".NET - Umbraco CMS",
    demoUrl: "http://themes.demo.3si.vn/themes",
    liveUrl: "http://themes.3si.vn/themes",
    group: ["S1"]
  },
  {
    id: 15,
    name: "3S Rental",
    desc: "Management system of rental apartments and houses in new urban areas",
    code: "rental",
    tech: ".NET MVC",
    demoUrl: "http://rental.demo.3si.vn",
    liveUrl: "http://rental.3si.vn",
    group: ["S1","S2"]
  },
  {
    id: 16,
    name: "3SEmpiere",
    desc: "Web platform for ERP, CRM and SCM",
    code: "3sadempiere",
    tech: "Java - ZK framework",
    demoUrl: "http://3sempiere.demo.3si.vn/webui/",
    liveUrl: "http://3sempiere.demo.3si.vn/webui/",
    group: ["S2"]
  },
  {
    id: 17,
    name: "3S Insight",
    desc: "Management tool of the entire project lifecycle with built-in analytics and dashboards for reporting",
    code: "insight",
    tech: "Ruby - Rails framework",
    demoUrl: "http://pro.insight.3si.vn/",
    liveUrl: "http://pro.insight.3si.vn/",
    group: ["S2"]
  },
  {
    id: 18,
    name: "3S HRM",
    desc: "Complete and customizable HR management system",
    code: "3shrm",
    tech: "PHP - Symfony framework",
    demoUrl: "http://hrm.3si.vn/",
    liveUrl: "http://hrm.3si.vn/",
    group: ["S2"]
  },
  {
    id: 19,
    name: "3SRM",
    desc: "Automated recruitment management system",
    code: "3srm",
    tech: "C# - .NET",
    demoUrl: "http://3srm.3si.vn/",
    liveUrl: "http://3srm.3si.vn/",
    group: ["ET","S2"]
  },
  {
    id: 20,
    name: "Aigoo theme",
    desc: "Electronics devices shopping e- commerce theme",
    code: "aigoo",
    tech: "Grandnode",
    demoUrl: "https://aigootheme.3si.vn/",
    liveUrl: "https://grandnode.com/aigoo-theme-3s-intersoft",
    group: ["S1"]
  },
  {
    id: 21,
    name: "Bipolar theme",
    desc: "Electronics devices shopping e- commerce theme",
    code: "bipolar",
    tech: "Grandnode",
    demoUrl: "https://bipolartheme.3si.vn/",
    liveUrl: "https://grandnode.com/bipolar-theme",
    group: ["S1"]
  },
  {
    id: 22,
    name: "Viviandancewears website",
    desc: "World wide Latin dance wear shopping site for all",
    code: "viviandancewears",
    tech: "Grandnode",
    demoUrl: "https://viviandancewears.com/",
    liveUrl: "https://viviandancewears.com/",
    group: ["S1"]
  }
];



// WEBPACK FOOTER //
// ./src/views/ViewData/DashboardData.jsx